import React, { useMemo } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

interface MarkedProps {
    children: string;
    sx?: SxProps<Theme>;
}

// Настраиваем один раз для всего приложения
marked.setOptions({
    breaks: true,
    gfm: true
});

export const Marked: React.FC<MarkedProps> = ({ children, sx }) => {
    // useMemo пересчитывает HTML только если текст изменился (важно для скорости)
    const cleanHtml = useMemo(() => {
        const rawHtml = marked.parse(children || '') as string;
        return DOMPurify.sanitize(rawHtml);
    }, [children]);

    return (
        <Box
            sx={{
                display: 'block',
                width: '100%',
                '& p': { m: 0, mb: 0.5 }, // Минимальный отступ между абзацами
                '& p:last-child': { mb: 0 },
                '& ul, & ol': { pl: 2, m: 0 },
                ...sx // Позволяем прокидывать дополнительные стили снаружи
            }}
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
    );
};
